var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Col',_vm._l((_setup.relevantMenuItems),function(menuItem){return _c('div',{key:menuItem.text,staticClass:"menu-item-container display-flex flex-row flex-align-center pl-3",on:{"click":function($event){$event.stopPropagation();return (() => {
				_setup.emit('option-clicked');
				menuItem.onClick();
			}).apply(null, arguments)}}},[_c('AppIcon',{staticClass:"mr-2 mt-1",attrs:{"name":menuItem.iconName}}),_c('h3',{staticClass:"reg"},[_vm._v(_vm._s(menuItem.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }